import alertPageTypes from "./alertPage.types";

export const toggleAlertPageIsVisible = () => ({
  type: alertPageTypes.TOGGLE_VISIBILITY,
});

export const setAlertPageMessage = (text) => ({
  type: alertPageTypes.SET_MESSAGE,
  payload: text,
});

export const setAlertPageFirstBtn = (text) => ({
  type: alertPageTypes.SET_FIRST_BTN,
  payload: text,
});
export const setAlertPageFirstBtnFunc = (func) => ({
  type: alertPageTypes.SET_FIRST_BTN_FUNC,
  payload: func,
});

export const setAlertPageSecondBtn = (text) => ({
  type: alertPageTypes.SET_SECOND_BTN,
  payload: text,
});
export const setAlertPageSecondBtnFunc = (func) => ({
  type: alertPageTypes.SET_SECOND_BTN_FUNC,
  payload: func,
});

export const setAlertPageClean = () => ({
  type: alertPageTypes.SET_ALERTPAGE_CLEAN,
});
